import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationTimeslotKindExceptionToEmployees from 'graphql/mutations/MutationTimeslotKindExceptionToEmployees'
import MutationTimeslotKindExceptionToTeams from 'graphql/mutations/MutationTimeslotKindExceptionToTeams'
import MutationTimeslotKindExceptionToJobtitles from "graphql/mutations/MutationTimeslotKindExceptionToJobtitles";

export default class MutateTimeslotKindExceptionTo {

	static Employees = ( timeslotKindExceptionGuid, employeeGuids, { callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		graphqlBuilder.addQuery( `timeslot-kind-exception-to-employees`, MutationTimeslotKindExceptionToEmployees, {
			timeslot_kind_exception_guid: timeslotKindExceptionGuid,
			employee_guid: employeeGuids,
		});
		
		graphqlBuilder.setOnStart( callbackStart )
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( result )
			}
		})
		
		graphqlBuilder.execute();
	}
	
	static Teams = ( timeslotKindExceptionGuid, teamGuids, { callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		graphqlBuilder.addQuery( `timeslot-kind-exception-to-teams`, MutationTimeslotKindExceptionToTeams, {
			timeslot_kind_exception_guid: timeslotKindExceptionGuid,
			team_guid: teamGuids,
		});
		
		graphqlBuilder.setOnStart( callbackStart )
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( result )
			}
		})
		
		graphqlBuilder.execute();
	}

	static Jobtitles = ( timeslotKindExceptionGuid, jobtitleGuids, { callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		graphqlBuilder.addQuery( `timeslot-kind-exception-to-jobtitles`, MutationTimeslotKindExceptionToJobtitles, {
			timeslot_kind_exception_guid: timeslotKindExceptionGuid,
			jobtitle_guid: jobtitleGuids,
		});
		
		graphqlBuilder.setOnStart( callbackStart )
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( result )
			}
		})
		
		graphqlBuilder.execute();
	}
}
